/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Aromas_TitleInputs */

const vi_trace_aromas_title = /** @type {(inputs: Trace_Aromas_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hương chè`)
};

/**

* @param {Trace_Aromas_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_aromas_title = /** @type {((inputs?: Trace_Aromas_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Aromas_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_aromas_title(inputs)
});